import HistoryGrid from "./HistoryGrid";

const History = ({tableData}) => {
  return (
    <div>
      <h1 className="mt-9 text-lg font-semibold">History</h1>
      <HistoryGrid data={tableData} />
    </div>
  );
};

export default History;
